<template>
    <div ref="wrapper">
        <slot />
    </div>
</template>

<script lang="ts">
import { screens } from '../../plugins/breakpoints';

export default {
    props: {
        hasTitles: { type: Boolean, default: true },
    },
    data() {
        return {
            resizeFrame: null as number | null,
        };
    },
    mounted(): void {
        window.addEventListener('resize', this.resize);
        this.resize();
        document.fonts.ready.then(() => {
            if (this.$refs.wrapper) this.resize();
        });
    },
    beforeUnmount(): void {
        window.removeEventListener('resize', this.resize);
        if (this.resizeFrame !== null) cancelAnimationFrame(this.resizeFrame);
    },
    methods: {
        resize(): void {
            if (this.resizeFrame !== null) cancelAnimationFrame(this.resizeFrame);

            this.resizeFrame = requestAnimationFrame(() => this.setTitleHeights());
        },
        setTitleHeights(): void {
            if (this.hasTitles) {
                const h4s = this.$refs.wrapper.querySelectorAll('h4');
                const titles = Array.prototype.slice.call(h4s) as HTMLHeadingElement[];

                titles.forEach(title => {
                    title.style.height = '';
                });

                if (window.innerWidth >= screens.md) {
                    const height = titles.reduce((acc, curr) => Math.max(acc, curr.clientHeight), 0);
                    titles.forEach(title => {
                        title.style.height = `${height}px`;
                    });
                }
            }
        },
    },
};
</script>
